import { ChangeDetectorRef, Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { _HttpClient } from '@delon/theme';

import { SelectBaseComponent } from '../select-base';

@Component({
  selector: 'app-pinv-select',
  templateUrl: './pinv-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PinvSelectComponent),
      multi: true
    }
  ]
})
export class PinvSelectComponent extends SelectBaseComponent {
  constructor(http: _HttpClient, cdr: ChangeDetectorRef) {
    super(http, cdr);
  }

  getUrl(searchValue: string): string {
    let filter = ``;
    if (searchValue) {
      const searchStr = searchValue.replaceAll("'", "''");
      filter = `(contains(docCode, '${encodeURIComponent(
        searchStr
      )}') or contains(billFrom,'${encodeURIComponent(searchStr)}'))`;
    }
    let url = `api/purchaseInvoices/lookup?$expand=currency($select=code)&$top=20&$skip=0&$orderby=docCode desc`;
    if (filter) url += `&$filter=${filter}`;
    return url;
  }
}
